import { type RepoPaginationResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginationResponse'
import { CatalogPermissionConfigList } from '@webapp/modules/purchasing/components/CatalogPermissionConfigList'
import { type CatalogPermissionSecondaryCategoryConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import messages from './messages'

export interface ICatalogPermissionSecondaryCategoryConfigTableProps {
  items: CatalogPermissionSecondaryCategoryConfig[]
  selectedSecondaryCategoryId: Nullable<number>
  onSelectSecondaryCategory: (
    secondaryCategory: CatalogPermissionSecondaryCategoryConfig
  ) => void
  isLoading: boolean
  isError: boolean
  searchValue: string
  onSearchChange: (value: string) => void
  onSearchSubmit: (value: string) => void
  paging: RepoPaginationResponse
  onPageChange: (page: number) => void
}

export const CatalogPermissionSecondaryCategoryConfigTable = ({
  items,
  selectedSecondaryCategoryId,
  onSelectSecondaryCategory,
  ...listProps
}: ICatalogPermissionSecondaryCategoryConfigTableProps) => (
  <CatalogPermissionConfigList
    items={items}
    getItemLabel={(secondaryCategory) => secondaryCategory.name}
    selectedId={selectedSecondaryCategoryId}
    onSelect={onSelectSecondaryCategory}
    messages={messages}
    {...listProps}
  />
)

CatalogPermissionSecondaryCategoryConfigTable.displayName =
  'CatalogPermissionSecondaryCategoryConfigTable'
